import { useParams } from "react-router-dom";
import { useRecommendations } from "../hooks/useRecommendations";
import ReactGA from "react-ga4";
import PageLayout from "./PageLayout.js";
import "./HomePage.css";
import { useEffect } from "react";

export default function ShowPage() {
  const { id } = useParams();

  const { data: records = [], isLoading } = useRecommendations(id);
  const hasRecommender = records.some(
    (r) => r.fields?.Recommender?.length > 0
  );

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  const readableTitle =
    id === "imperfects"
      ? "the imperfects"
      : id === "lifeuncut"
      ? "life uncut"
      : id === "mamamiaoutloud"
      ? "mamamia out loud"
      : id;

  const filterKeys = hasRecommender ? ["Category", "Recommender"] : ["Category"];

  return (
    <PageLayout
      title={readableTitle}
      records={records}
      loading={isLoading}
      hasRecommender={hasRecommender}
      filterKeys={filterKeys}
      hideSort={false}
    />
  );
}
